<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>
<script setup lang="ts">
const url = useRequestURL()
const baseUrl = url.origin 

useHead({
  meta: [
      {
        property: 'og:title',
        content: 'NuxtStore – Shop Tools, Electronics, Home & More Online',
      },
      {
        property: 'og:description',
        content:
          'Discover premium tools and accessories at NuxtStore. Explore our wide range of products with fast delivery and great deals.',
      },
      {
        property: 'og:image',
        content: `${baseUrl}/images/og-image.png`,
      },
      {
        property: 'og:image:secure_url',
        content: `${baseUrl}/images/og-image.png`,
      },
      { property: 'og:image:alt', content: 'Nuxt.Store' },
      { property: 'og:type', content: 'website' },
      {
        property: 'og:url',
        content: baseUrl,
      },
    ],
});
</script>
